import { AwesomeComponent, AwesomeEvent, ContainerProvider, Oswald } from './component';
import ComponentAPI from './component-api';
import ComponentType from './component-type';
import { Catalog } from './registry';
import SingleSourceOfTruth from './single-source-of-truth';

export * from './types';

export {
  AwesomeComponent,
  AwesomeEvent,
  Catalog,
  ComponentAPI,
  ComponentType,
  ContainerProvider,
  Oswald,
  SingleSourceOfTruth,
};
